import { Button, Col, Dropdown, Layout, Menu, message, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks/hooks';
import { userSubMenu } from '../../../utils/functions';
import Navbar from '../../Organisms/Navbar/Navbar';
import { UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import './CatastroTemplate.less';
import UploadFiles from '../../Atoms/UploadFiles/UploadFiles';
import SectionIndicator, { subsections } from '../../Molecules/SectionIndicator/SectionIndicator';
import { ReactComponent as CapasEnabled } from '../../../res/svg/capas-green.svg';
import { ReactComponent as CapasMenu } from '../../../res/svg/capas-black.svg';
import { useEffect, useRef, useState } from 'react';
import { getLastUpdateLayersCM, getListCapasCatastroMinero, uploadCapasCatastroMineroOrAuxiliares } from '../../../store/slice/gestorCapasSlice';
import { GestorCapas, subirGestorCapas } from '../../../models/GestorCapas';
import moment from 'moment';

/**
 * @page CatastroTemplate.tsx
 * @description CatastroTemplate.
 * @return { Template }
 */
function CatastroTemplate() {
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const itemsCallback = (item: string) => {
    userSubMenu(item, navigate, dispatch);
  };
  const { Text } = Typography;

  const [tipoCapaCatastro, setTipoCapaCatastro] = useState('');
  const [listCatastroMinero, setListCatastroMinero] = useState<GestorCapas[]>([])
  const [disabledButtonCatastroMinero, setDisabledButtonCatastroMinero] = useState<boolean>(false);
  const [disabledButtonCapasAuxiliares, setDisabledButtonCapasAuxiliares] = useState<boolean>(false);
  const [lastUpdateLayersCM, setLastUpdateLayersCM] = useState<{
    lastUpdateDate?: string | null;
    lastUpdateLayerFilename?: string | null;
  }>({});
  const buttonRefCatastro = useRef<any>();
  //@ts-ignore
  const currentUser: User = JSON.parse(localStorage.getItem('currentUser'))
  
  const permissionUploadCapas = () =>{
    if(!currentUser.accesoCatastro){
      navigate('dashboard')
    }
  }

  const fetchLastUpdateLayersCM = async () =>{
    const ultimaCapaCM = await dispatch(getLastUpdateLayersCM());
    setLastUpdateLayersCM((ultimaCapaCM.payload as any).data);
  }

  const uploadCapasCatastro = (tipoCapa: string) =>{
    setTipoCapaCatastro(tipoCapa);
    buttonRefCatastro.current.click();
  }

  const capasCatastroMinero = () => {
    const menuCapasCatastroMinero = listCatastroMinero.map((value: GestorCapas, index)=>(
      {
        key: index,
        label: <Text className="ml-drop-menu__label">{value.title}</Text>,
        icon: <CapasMenu />,
        onClick: ()=>uploadCapasCatastro(value.nativeName),
      }
    ))
    return (
      <Menu 
        items={menuCapasCatastroMinero}
      />
    )
  }
  
  const postRequestCatastroMinero = async (options: any) => {
    
    const { onSuccess, onError, file} = options;

    const capaCatastroMinero: subirGestorCapas = {
      files: file,
      capa: tipoCapaCatastro,
      datastore: 'postgis',
      datasource: 'CM',
      tipo: 'vectorial'
    }

    setDisabledButtonCatastroMinero(true)
    dispatch(uploadCapasCatastroMineroOrAuxiliares(capaCatastroMinero)).then((value: any)=>{
      if(value.payload.status){
        onSuccess('ok');
        setDisabledButtonCatastroMinero(false)
      }
      else {
        onError(value.payload.data.error);
        setDisabledButtonCatastroMinero(false)
      }
    })
  };

  const postRequestCapasAuxiliares = async (options: any) => {
    const { onSuccess, onError, file} = options;

    const capaAuxiliar: subirGestorCapas = {
      files: file,
      datastore: 'postgis',
      datasource: 'CA',
      tipo: 'vectorial'
    }

    setDisabledButtonCapasAuxiliares(true)
    dispatch(uploadCapasCatastroMineroOrAuxiliares(capaAuxiliar)).then((value: any)=>{
      if(value.payload.status){
        onSuccess('ok');
        setDisabledButtonCapasAuxiliares(false)
      }
      else {
        onError(value.payload.data.error);
        setDisabledButtonCapasAuxiliares(false)
      }
    })
  };

  const props: UploadProps = {
    onChange(info) {
      if (info.file.status === 'done') {
        message.success(`Archivo subido correctamente`);
      } else if (info.file.status === 'error') {
        message.error(`Ocurrió un error al subir el archivo. Por favor intenta nuevamente`);
      }
    },
    accept:'.zip',
    showUploadList:{
      showRemoveIcon: false,
    }
  };

  useEffect(() => {
    permissionUploadCapas()
    fetchLastUpdateLayersCM()
    dispatch(getListCapasCatastroMinero()).then((value: any)=>{
        setListCatastroMinero(value.payload.data);
    })
  }, []);
  
  return (
    <Layout>
      <Navbar showItems={true} currentScreen={'gestor-de-capas'} itemsCallback={itemsCallback} subsection={'catastro'}/>
      <SectionIndicator subsection={subsections.gestorCapas} />
      <Layout className="tp-task__layout">
        <Row>
          <Col span={19}>
            <div className={'container-title'}>
              <CapasEnabled/>
              <div className={'contaier-content-text'}>
                <div className={'ml-section-indicator__section_2'}>
                  ¿Qué Capas quieres subir hoy?
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row style={{paddingTop: '20px'}}>
          <Col span={12}>
            <div className={'container-content'} style={{minHeight: '310px'}}>
                <Text strong style={{color: '#595959', fontSize: '18px', textAlign: 'center'}}>Catastro Minero </Text>
                <div className={'ml-section-indicator__section_1'}>
                Para actualizar una capa del Catastro Minero:
                </div>
                <div className={'content-numbers'}>
                  <span>1. Elige en el listado la capa que quieres actualizar. </span>
                  <span>2. Recuerda que solo se admiten archivos .zip.</span>
                  <span>3. El archivo .zip debe contener al menos los siguientes archivos: .shp y .prj.</span>
                  <span>4. Todos los archivos deben estar directamente en el archivo .zip (sin subcarpetas).</span>
                  <span><i>*NOTA: Se recomienda que en el .zip esté el archivo .sld (estilo de la capa), en caso contrario Geoserver asignará uno por defecto.</i></span>
                </div>
                <br />
                {lastUpdateLayersCM.lastUpdateDate !== undefined && (
                <div className="last-update-layers-cm">
                  <span>{`Fecha última actualización: ${
                    moment(lastUpdateLayersCM.lastUpdateDate).format("DD/MM/YYYY HH:mm") ?? 'SIN FECHA'
                  } (${
                    lastUpdateLayersCM.lastUpdateLayerFilename ?? 'SIN ARCHIVO'
                  })`}</span>
                </div>
              )}
            </div>
            <div className={'container-upload-capas'}>
              <Dropdown overlay={capasCatastroMinero}>
                <Button type={'primary'}
                        className={'button-catastro'}
                        icon={<UploadOutlined />}
                >
                  CAPAS DE CATASTRO MINERO
                </Button>
              </Dropdown>
              
              <UploadFiles
                ref={buttonRefCatastro}
                customRequest={postRequestCatastroMinero}
                disabledButton={disabledButtonCatastroMinero}
                propsUpload={props}
                hiddenUpload={true}
              />
            </div>
          </Col>
          <Col span={12}>
            <div className={'container-content'} style={{minHeight: '310px'}}>
                <Text strong style={{color: '#595959', fontSize: '18px', textAlign: 'center'}}>Capas Auxiliares </Text>
                <div className={'ml-section-indicator__section_1'}>
                Para crear una capa nueva o actualizar una capa existente:
                </div>
                <div className={'content-numbers'}>
                  <span>1. Elige el archivo que quieres subir.</span>
                  <span>2. Recuerda que solo se admiten archivos .zip. </span>
                  <span>3. El archivo .zip debe contener al menos los siguientes archivos: .shp y .prj.</span>
                  <span>4. Si el nombre del shapefile NO existe en el geoserver, se creará una capa nueva. </span>
                  <span>5. Si el nombre de shapefile SI existe en el geoserver, se actualizará la capa. </span>
                  <span>6. El nombre del shapefile no puede ser el nombre de ninguna capa del Catastro Minero, ni de los Productos Satelites.</span>
                  <span><i>*NOTA: Se recomienda que en el .zip esté el archivo .sld (estilo de la capa), en caso contrario Geoserver asignará uno por defecto.</i></span>
                </div>
            </div>
            <div className={'container-upload-capas'}>
            <UploadFiles
                listType='picture'
                textButton={'CAPAS AUXILIARES'} 
                customRequest={postRequestCapasAuxiliares} 
                icon={<UploadOutlined/>} 
                colorButton={'#9D79F1'}
                widthButton={'266px'}
                propsUpload={props}
                typeButton={'primary'}
                disabledButton={disabledButtonCapasAuxiliares}
              />
            </div>
          </Col> 
        </Row>
      </Layout>
    </Layout>
  );
}

export default CatastroTemplate;
